<template>
  <div class="wechat-root">

    <van-notice-bar
      left-icon="video-o"
      :text="noticeMsg"
      scrollable
    />
    <van-steps :active="stepsActive">
      <van-step>粘贴链接</van-step>
      <van-step>点击解析</van-step>
      <van-step>下载视频</van-step>
    </van-steps>


    <!-- Field 是基于 Cell 实现的，可以使用 CellGroup 作为容器来提供外边框。 -->
    <van-field class="shareUrl" v-model="shareUrl" label="" placeholder="请输入文章链接">
      <template #button>
        <van-button :loading="isParseBtnLoading"  :disabled="isParseBtnLoading"   :loading-text="parseBtnLoadingText" @click="parseData" size="small" type="primary">&nbsp;解&nbsp;&nbsp;析&nbsp;</van-button>
      </template>
    </van-field>

    <van-list
      style="margin-top: 15px"
      v-model="loading"
      :immediate-check="false"
      :finished="finished"
      finished-text="加载完成"
    >
      <van-field v-for="(item,index) in list" :key="item.id" :value="item.name" :id="index" readonly>
        <template #button>
          <van-button @click="download(index)" size="small" type="info">&nbsp;下&nbsp;&nbsp;载&nbsp;</van-button>
        </template>
      </van-field>
    </van-list>


  </div>
</template>

<script>

import Vue from 'vue';
import {Button} from 'vant';
import {Icon} from 'vant';
import {NoticeBar} from 'vant';
import {Step, Steps} from 'vant';
import {Field} from 'vant';
import {Dialog} from 'vant';
import {Loading} from 'vant';
import {List} from 'vant';
import {Toast} from 'vant';

Vue.use(Toast);
Vue.use(List);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Step);
Vue.use(Steps);
Vue.use(NoticeBar);
Vue.use(Icon);
Vue.use(Button);

export default {
  name: "WechatVideo",
  data() {
    return {
      noticeMsg: '当前功能免费，解析次数不限，可以下载任意微信公众号文章内部的视频。技术支持——<老友极客社>公众号，power by shaofeer……',
      tabsActive: 2,
      stepsActive: -1,
      shareUrl: "",
      isParseBtnLoading: false,
      list: [],
      loading: false,
      finished: false,
      parseBtnLoadingText: "正在解析...",
      rootShow: false
    }
  },
  watch: {
    shareUrl: function (n, o) {

      if (this.isParseBtnLoading) {
        return;
      }

      if (n) {
        this.stepsActive = 0
      } else {
        this.stepsActive = -1
      }
    },
    isParseBtnLoading: function (n, o) {
      if (n && this.shareUrl) {
        this.stepsActive = 1
      } else if (this.shareUrl) {
        this.stepsActive = 2
      }
    }
  },
  methods: {
    parseData: function () {

      if (!this.shareUrl) {
        Toast.fail('请输入链接');
        return;
      }

      if (this.shareUrl.indexOf("mp.weixin.qq.com") === -1) {
        Toast.fail('请检查链接');
        return;
      }

      this.isParseBtnLoading = true

      let _this = this;
      this.axios.post('https://api.wintp.top:8443/api/gwrWechatVoice/parserVideo?url=' + this.shareUrl).then(res => {
        if (res.data.code !== '200') {
          Toast.fail(res.data.msg);
        }

        _this.isParseBtnLoading = false
        _this.list = res.data.data || [];
        // 加载状态结束
        _this.loading = false;
        _this.finished = true;
      }).catch(res => {
      })
    },

    download: function (index) {
      let voiceEncodeFileid = this.list[index].voiceEncodeFileid;
      window.location.href = 'https://api.wintp.top:8443/api/gwrWechatVoice/download?id=' + voiceEncodeFileid
    },
    isWechatOpen: function () {

      // return true;

      var ua = window.navigator.userAgent.toLowerCase();
      // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
      if (ua.indexOf('micromessenger') > -1) {
        return true; // 是微信端
      } else {
        return false;
      }
    },
    pollingWechat: function () {
      if (this.isWechatOpen()) {
        this.rootShow = true
      } else {
        Dialog.alert({
          message: '请在微信中打开该链接',
          theme: 'round-button',
        }).then(() => {
          this.pollingWechat()
        });
      }
    }
  },
  created() {
    this.pollingWechat()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.shareUrl {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/module/WechatVideo.vue